module.exports = __webpack_public_path__ + "img/Bin food identification method.0ba8c3f7.png";